<script setup lang="ts">
import type { Article } from '~/types/article'

type HomepageArticle = Pick<Article, 'title' | 'slug' | 'excerpt' | 'thumbnail_url' | 'tags' | 'published_at'>

const { data: articles } = await useFetch<HomepageArticle[]>('/api/articles/latest', {
  key: 'homepage-blog-articles',
  default: () => []
})
</script>

<template>
  <section
    id="blog"
    class="py-12"
  >
    <div class="flex items-center justify-between mb-6">
      <h2 class="text-xs font-semibold uppercase tracking-widest text-muted">
        Latest Articles
      </h2>
      <UButton
        v-if="articles.length"
        to="/blog"
        variant="ghost"
        size="xs"
        trailing-icon="i-lucide-arrow-right"
      >
        View all
      </UButton>
    </div>

    <div
      v-if="articles.length > 0"
      class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4"
    >
      <BlogCard
        v-for="article in articles"
        :key="article.slug"
        :title="article.title"
        :slug="article.slug"
        :excerpt="article.excerpt"
        :thumbnail_url="article.thumbnail_url"
        :tags="article.tags"
        :published_at="article.published_at"
      />
    </div>

    <div
      v-else
      class="py-12 text-center text-muted"
    >
      <UIcon
        name="i-lucide-pen-line"
        class="size-8 mx-auto mb-3 opacity-30"
      />
      <p class="text-sm">
        No articles published yet.
      </p>
    </div>
  </section>
</template>
